import { Pipe, PipeTransform } from '@angular/core'
import { format, parseISO } from 'date-fns'

@Pipe({
    name: 'displayDate',
})
export class DisplayDatePipe implements PipeTransform {

    transform(date: number | string | Date): string {
        if (!date) {
            return ''
        }
        if (typeof(date) === 'string') {
            return format(parseISO(date as string), 'd.M.y')
        } else {
            return format(date, 'd.M.y')
        }
    }

}
